import { render, staticRenderFns } from "./GlavnaBocnaTraka.vue?vue&type=template&id=49a448dd&scoped=true&"
import script from "./GlavnaBocnaTraka.vue?vue&type=script&lang=js&"
export * from "./GlavnaBocnaTraka.vue?vue&type=script&lang=js&"
import style0 from "./GlavnaBocnaTraka.vue?vue&type=style&index=0&id=49a448dd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a448dd",
  null
  
)

export default component.exports